import { useQueryClient, useMutation } from '@tanstack/react-query'
import { approveApprovals, unapproveApprovals } from '@lib/api'
import { approvalKeys } from '@lib/keys'
import { pollBatchOperation } from '@utils/pollBatchOperationStatus'

export const useBulkApproval = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (approvalIds: number[]) => {
      // Small batches are processed within the request and resolve
      // immediately. Larger batches return a Batch Operation that performs
      // the work in the background; we poll its status until it completes,
      // then resolve the mutation (or reject if it failed).
      const response = await approveApprovals(approvalIds)
      if (response) return pollBatchOperation(response.batchOperation)
    },
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(approvalKeys.all)
      },
    },
  )
}

export const useBulkUnapproval = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (approvalIds: number[]) => {
      // Small batches are processed within the request and resolve
      // immediately. Larger batches return a Batch Operation that performs
      // the work in the background; we poll its status until it completes,
      // then resolve the mutation (or reject if it failed).
      const response = await unapproveApprovals(approvalIds)
      if (response) return pollBatchOperation(response.batchOperation)
    },
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(approvalKeys.all)
      },
    },
  )
}
